<template>Attempting to log you in....</template>

<script setup>
import { useAuthenticationStore } from "@/stores/authentication";
import { useRouter, useRoute } from "vue-router";

const authenticationStore = useAuthenticationStore();
const router = useRouter();
const route = useRoute();

const success = authenticationStore.loginSso();
if (success) {
  authenticationStore.level = authenticationStore.jwtData.authentication_type;
  const user_type = authenticationStore.jwtData.authentication_type;
  authenticationStore.fetchProfile().then(() => {
    if (user_type == "parent") {
      router.push("/" + route.params.account);
    } else if (user_type == "teacher") {
      router.push("/" + route.params.account + "/teacher");
    } else if (user_type == "school" || user_type == "district") {
      router.push("/" + route.params.account + "/school");
    } else if (user_type == "support"){
      router.push("/support");
    }
  });
} else {
  router.push("/" + route.params.account + "/login");
  console.log("Login Failed");
}
</script>
